import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get } from 'lodash'
import { useSnackbar } from 'notistack'
import { Button, CircularProgress, Container, Grid, TextField, Typography } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import storePurchaseStyles from './css/storePurchaseStyles'
import StepCard from '../../components/cards/StepCard/StepCard'
import BoletaTienda from '../../assets/svg/boletaTienda.svg'
import useFormHooks from '../../components/hooks/useFormHooks'
import ClientHeader from '../../sections/headers/ClientHeader/ClientHeader'

const StorePurchase = () => {
  const classes = storePurchaseStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [purchaseDate, setPurchaseDate] = useState(new Date())

  const initialState = {
    branch: '',
    cashNumber: '',
    transactionNumber: '',
    dni: '',
  }
  const { handleSubmit, handleInputChange, inputs, clearInputs } = useFormHooks(
    initialState,
    async () => {
      setIsLoading(true)
      try {
        setIsLoading(false)
        clearInputs()
        return history.push({
          pathname: 'seleccionar-productos',
        })
      } catch (error) {
        enqueueSnackbar(
          get(error, 'message') || get(error, 'response.data.error_description') || '',
          {
            variant: 'error',
            autoHideDuration: 1000,
          }
        )
        setIsLoading(false)

        return error
      }
    }
  )

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <ClientHeader
          title="Compra en tienda física"
          subTitle="Para crear tu ticket de regalo, primero sigue estas instrucciones:"
          step="1"
          totalSteps="3"
        />
        <Grid container spacing={2} alignItems="center" justify="center">
          <Grid item xs={12}>
            <StepCard stepNumber={1}>
              <>
                <Typography align="left">
                  Encuentra tu boleta de venta electrónica que te entregaron en caja.
                </Typography>
              </>
            </StepCard>
          </Grid>
          <Grid item xs={12}>
            <StepCard stepNumber={2}>
              <>
                <Typography align="left">
                  En tu boleta, ubica los siguientes datos tal como se muestra en la imagen:
                </Typography>
                <img src={BoletaTienda} alt="Boleta Tienda" className={classes.img} />
              </>
            </StepCard>
          </Grid>
          <Grid item xs={12}>
            <StepCard stepNumber={3}>
              <form className={classes.formSection} onSubmit={handleSubmit}>
                <Typography align="left" className={classes.textField}>
                  En tu boleta, ubica los siguientes datos tal como se muestra en la imagen:
                </Typography>
                <TextField
                  fullWidth
                  label="1 - Sucursal"
                  variant="outlined"
                  name="branch"
                  value={get(inputs, 'branch')}
                  onChange={handleInputChange}
                  className={classes.textField}
                />
                <TextField
                  fullWidth
                  label="2 - Caja"
                  variant="outlined"
                  name="cashNumber"
                  value={get(inputs, 'cashNumber')}
                  onChange={handleInputChange}
                />
                <KeyboardDatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="MM/DD/yyyy"
                  margin="normal"
                  id="pruchase-date"
                  label="3 - Fecha de compra"
                  value={purchaseDate}
                  onChange={setPurchaseDate}
                  KeyboardButtonProps={{
                    'aria-label': 'pruchase-date',
                  }}
                  inputVariant="outlined"
                  className={classes.datePicker}
                />
                <TextField
                  fullWidth
                  label="4 - Transacción"
                  variant="outlined"
                  name="transactionNumber"
                  value={get(inputs, 'transactionNumber')}
                  onChange={handleInputChange}
                  className={classes.textField}
                />
                <TextField
                  fullWidth
                  label="5 - DNI / CE del cliente"
                  variant="outlined"
                  name="dni"
                  value={get(inputs, 'dni')}
                  onChange={handleInputChange}
                  className={classes.textField}
                />
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ height: 56 }}
                >
                  {isLoading ? <CircularProgress /> : 'Continuar'}
                </Button>
              </form>
            </StepCard>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default StorePurchase
